import Model from "./base/model";

class GeolocationDriver extends Model{
  resourceName() {
    return "geolocation_drivers";
  }

  fields() {
    return {
      lat: "",
      long: "",
      order_id: "",
      location_captured_at: "",
      tracing_source: "",
      description: "",
      return_api: "",
      order: { jsonApi: "hasOne", type: "orders"},
      created_at: ""
    };
  }
}

export default new GeolocationDriver();
